import React, { useEffect, useState } from 'react';
import '../../css/Dashboard.css';
import { useDashboardData } from './DashboardDataContext';

interface FollowUpsComponentProps {
  onCustomerClick?: (customerId?: number) => void;
}

const FollowUpsComponent: React.FC<FollowUpsComponentProps> = ({ onCustomerClick }) => {
  const [followUps, setFollowUps] = useState<any[]>([]);
  const { data } = useDashboardData();
  useEffect(() => {
    if (!data) return;
    const list = (data.followups||[]).map((f:any)=>({
      name: f.customerName || f.customer?.name || '—',
      customerId: f.customer?.id ?? f.customerId ?? f.customer_id,
      date: f.date || f.followupDate || '',
      time: (f.time || '').substring(0,5),
      task: f.description || f.queryType || ''
    }));
    setFollowUps(list);
  }, [data]);

  return (
    <div>
      <div className="db-card-header">
        <h4 style={{ margin: 0 }}>Today's Follow-ups</h4>
      </div>
      <div>
        {followUps.map((f, i) => (
          <div key={i} className="list-item">
            <div>
              {f.customerId && onCustomerClick ? (
                <button
                  type="button"
                  className="li-title dashboard-customer-link"
                  onClick={() => onCustomerClick(Number(f.customerId))}
                >
                  {f.name}
                </button>
              ) : (
                <div className="li-title">{f.name}</div>
              )}
              <div className="li-sub">Due {f.date ? new Date(f.date).toLocaleDateString() : ''} {f.time ? `· ${f.time}` : ''}</div>
              <div className="li-sub" style={{ marginTop: 4 }}>{f.task}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FollowUpsComponent;
